import { section } from "@/glow";
import { animateStandard, shouldAnimate } from "@/lib/animation";
import ProductItem from "@/lib/product-item";

section("featured-collection", {
  onLoad() {
    this.productItem = ProductItem(this.container);

    if (shouldAnimate(this.container)) {
      this.animateFeaturedCollection = animateStandard(this.container);
    }
  },

  onUnload() {
    this.productItem && this.productItem.unload();
    this.animateFeaturedCollection?.destroy();
  },
});
